import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_LIVE,
  withCredentials: true, // This ensures cookies are sent with requests
});